var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
;
export var sharedTranslations = {
    base: {
        en_US: __assign(__assign(__assign(__assign(__assign(__assign({}, require('./shared/base/en_US.json')), require('./shared/acid_components/en_US.json')), require('./shared/central_provider/en_US.json')), require('./shared/changelogs/en_US.json')), require('./shared/core_profile_ui_tools/en_US.json')), require('./shared/apps/en_US.json')),
        fr_CA: __assign(__assign(__assign(__assign(__assign(__assign({}, require('./shared/base/fr_CA.json')), require('./shared/acid_components/fr_CA.json')), require('./shared/central_provider/fr_CA.json')), require('./shared/changelogs/fr_CA.json')), require('./shared/core_profile_ui_tools/fr_CA.json')), require('./shared/apps/fr_CA.json')),
    },
    ca_provinces: {
        en_US: require('./shared/ca_provinces/en_US.json'),
        fr_CA: require('./shared/ca_provinces/fr_CA.json'),
    },
    country_codes: {
        en_US: require('./shared/country_codes/en.json'),
        fr_CA: require('./shared/country_codes/fr.json'),
    },
    dates: {
        en_US: require('./shared/dates/en_US.json'),
        fr_CA: require('./shared/dates/fr_CA.json'),
    },
};
export function initMaestroTranslations(i18n, initReactI18next, resources, appendToGlobalScope, debug) {
    if (debug === void 0) { debug = false; }
    i18n.use(initReactI18next).init({
        fallbackLng: 'en_US',
        debug: debug,
        nsSeparator: false,
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en_US: {
                translation: __assign(__assign(__assign({}, sharedTranslations.base.en_US), (appendToGlobalScope.reduce(function (p, c) { return (__assign(__assign({}, p), c.en_US)); }, {}))), resources.en_US),
            },
            fr_CA: {
                translation: __assign(__assign(__assign({}, sharedTranslations.base.fr_CA), (appendToGlobalScope.reduce(function (p, c) { return (__assign(__assign({}, p), c.fr_CA)); }, {}))), resources.fr_CA),
            },
            es_MX: {
                translation: __assign(__assign(__assign({}, sharedTranslations.base.fr_CA), (appendToGlobalScope.reduce(function (p, c) { return (__assign(__assign({}, p), c.es_MX)); }, {}))), resources.fr_CA),
            },
        },
    });
    i18n.languages = ['en_US'];
}
